// e.g. mer 27/12/2023
export function ToFormatedDateWithWeekday(date) {
  if (date) {
    const formattedDate = date.toLocaleDateString("fr-FR", {
      timeZone: "Europe/Paris",
      weekday: "short",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return formattedDate;
  }
  return "";
}

// e.g. 17:23
export function ToFormatedHour(date) {
  if (date) {
    const formattedHour = date.toLocaleTimeString("fr-FR", {
      timeZone: "Europe/Paris",
      hour: "2-digit",
      minute: "2-digit",
    });
    return formattedHour;
  }
  return "";
}

// e.g. 2023-12-27
export function ToFormatedShortISODate(date) {
  if (date) {
    const _year = date.getFullYear();
    const _month = String(date.getMonth() + 1).padStart(2, "0");
    const _day = String(date.getDate()).padStart(2, "0");
    return `${_year}-${_month}-${_day}`;
  }
  return "";
}

// e.g. input 2/12/2023 output 2023-12-02
export function ToFormatedShortISODateFromDateString(dateStr) {
  if (dateStr) {
    let parts = dateStr.split('/');

    // Extract the day, month, and year
    let day = parts[0].padStart(2, '0'); // Ensure day is two digits
    let month = parts[1].padStart(2, '0'); // Ensure month is two digits
    let year = parts[2];

    // Construct the new date string in the desired format
    let newDateStr = `${year}-${month}-${day}`;
    return newDateStr
  }
  return "";
}


// e.g. input 2023-12-02 output 2/12/2023
export function ToFormatedBackendDateFromShortISODateString(dateStr) {
  if (dateStr) {
    // Split the input date string by '-'
    let parts = dateStr.split('-');

    // Extract the year, month, and day
    let year = parts[0];
    let month = parts[1];
    let day = parts[2];

    // Construct the new date string in the desired format
    let newDateStr = `${day}/${month}/${year}`;

    return newDateStr;
  }
  return "";
}

// e.g. 27-12-2023
export function ToFormatedShortDate(date) {
  if (date) {
    const _year = date.getFullYear();
    const _month = String(date.getMonth() + 1).padStart(2, "0");
    const _day = String(date.getDate()).padStart(2, "0");
    return `${_day}-${_month}-${_year}`;
  }
  return "";
}

// e.g. 27/12/2023 17:23
export function ToFormatedDateForEvents(date, allday) {
  const moment = require("moment-timezone");
  const parisDate = moment.tz(date, "Europe/Paris");
  parisDate.locale("fr"); // Set locale to French for day names
  return (
    (allday &&
      parisDate.format("ddd DD/MM/YYYY")) ||
    parisDate.format("ddd DD/MM/YYYY à HH:mm")
  );
}

// day = "2023-01-19";
// hour = "17:27";
// tz = "Europe/Paris"; // Replace with your specific timezone
export function ToFormatedISOTime(day, hour, tz) {
  const moment = require("moment-timezone"); // Import the moment-timezone library
  const combinedDateTimeString = `${day}T${hour}:00.000`;
  // Use moment-timezone to create a moment with the specified timezone
  if (!tz) {
    tz = "Europe/Paris";
  }
  const momentWithTz = moment.tz(combinedDateTimeString, tz);
  // Get the ISO date string
  const isoDate = momentWithTz.toISOString();
  return isoDate;
}

export const GetWeekDay = (day) => {
  switch (day) {
    case 0: {
      return "Dimanche";
    }
    case 1: {
      return "Lundi";
    }
    case 2: {
      return "Mardi";
    }
    case 3: {
      return "Mercredi";
    }
    case 4: {
      return "Jeudi";
    }
    case 5: {
      return "Vendredi";
    }
    case 6: {
      return "Samedi";
    }
    default: {
      return "-";
    }
  }
};

// retrive time HH:MM from datetime
export function GetTimeFromDate(dateString) {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}


export const CalculateAge = (birthday) => {
  var today = new Date();
  var birthDate = new Date(ToFormatedShortISODateFromDateString(birthday));
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};


// Helper function to format date to dd/mm/yyyy
export const FormatDateToDDMMYYYY = (date) => {
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

// Helper function to convert dd/mm/yyyy to Date object
export const ParseDateFromDDMMYYYY = (dateString) => {
  if (!dateString) return null;

  const [day, month, year] = dateString.split("/").map((part) => parseInt(part, 10));

  // Construct a new Date object from the parsed values
  return new Date(year, month - 1, day); // month is 0-indexed in JavaScript Date
};


// Helper function to combine date and time into a formatted string
export const CombineDateTime = (date, time) => {
  if (!date || !time) return null; // Handle cases where date or time is missing

  const moment = require("moment-timezone");
  
  // Extract date components
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  // Combine date and time in YYYY-MM-DD HH:mm format
  const dateTimeString = `${year}-${month}-${day} ${time}`;
  
  // Create moment in Paris timezone and convert to ISO string
  const parisDateTime = moment.tz(dateTimeString, "YYYY-MM-DD HH:mm", "Europe/Paris");
  
  return parisDateTime.toISOString(); // Return the combined date as an ISO string
};

// Helper function to extract the date part and time part from ISO string
export const ParseISODate = (isoString) => {
  const dateObj = new Date(isoString);
  const date = dateObj.toISOString().split("T")[0]; // Get the date part
  const time = dateObj.toTimeString().split(" ")[0].substring(0, 5); // Get the time part (HH:MM)
  return { date, time };
};
